<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width=350
            dark>
            <v-card color="error">
                <v-card-title>{{ $t("ERROR_TITLE") }}</v-card-title>
                <v-card-text>
                    {{ message }}
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="submit(true)">
                        <v-icon>mdi-refresh</v-icon>
                        {{ $t("TRY_AGAIN") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="submit(false)" text>
                        <v-icon>mdi-exit-to-app</v-icon>
                        {{ $t("BTN_CLOSE") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "RetryDialog",
    data() {
        return {
            display: false,
            message: null,
            target: null
        }
    },
    methods: {
        open(params) {
            this.target = params.target;
            this.message = params.message;
            this.display = true;
        },
        close() {
            this.display = false;
            this.message = null;
        },
        submit(retry) {
            this.$emit("submit", {target: this.target, retry});
            this.close();
        }
    }
}
</script>